export { TypeCard } from "./TypeCard";
